/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

import Config from '@/config'
import Vue from 'vue'
import HttpProvider from '@/services/HttpProvider'
import Graphql from '@/services/Graphql'
import Logger from '@/services/Logger'
import { getSuffixGuest, giftCardFormDecorator } from '@/helpers'
import each from 'lodash/each'
import find from 'lodash/find'

export default {
  getCartID (ctx, { invalid = false }) {
    if (ctx.state.cartId && !invalid) {
      return Promise.resolve(ctx.state.cartId)
    } else {
      let url = Config.API.cart[`create${getSuffixGuest(ctx.rootGetters)}`]
        .replace('{{storeViewCode}}', ctx.rootState.ui.storeViewCode)

      return HttpProvider.post(url)
        .then(resp => {
          ctx.commit('updCartId', resp.data)
          return ctx.state.cartId
        })
    }
  },
  getCartIDMask (ctx) {
    if (ctx.state.cartIdMask) {
      return Promise.resolve(ctx.state.cartIdMask)
    } else {
      // if user is guest load cartId
      if (!ctx.rootGetters['user/isLogged']) {
        return ctx.dispatch('getCartID', {})
          .then((res) => {
            ctx.commit('updCartIdMask', res)
            return res
          })
      } else {
        // Load customer masked cartID
        return Graphql.genericCall(
          {},
          ctx.rootState.user.token,
          ctx.rootState.ui.storeViewCode,
          'customerCart',
          null,
          false
        ).then(res => {
          const userCartId = res.data && res.data.customerCart ? res.data.customerCart.id : null
          ctx.commit('updCartIdMask', userCartId)
          return userCartId
        })
      }
    }
  },
  syncServerCart (ctx, { invalid = false, syncMinicart = true }) {
    ctx.commit('busySync', true)
    return ctx.dispatch('getCartID', { invalid })
      .then(cartId => {
        // pull items from server
        const promiseArr = []
        /* const promiseArr = [
          Vue.http.get(Config.API.cart.pull
            .replace('{{token}}', ctx.rootState.user.token || '')
            .replace('{{cartId}}', cartId))
            .then(res => res.body.result)
            .then(serverItems => {
              ctx.commit('updPullItems', { items: serverItems, invalid: true })
            })
        ] */
        if (syncMinicart) {
          // promiseArr.push(ctx.dispatch('shippingInfo', {}))
          promiseArr.push(ctx.dispatch('updateMinicart')
            .catch(err => {
              ctx.dispatch('user/logout', null, { root: true })
              /* if (err.response.status === 404) {
              } */
              console.error(err)
            })
            .then(() => ctx.state.items))
        }
        return Promise.all(promiseArr)
          .then(() => {
            ctx.commit('busySync', false)
            return ctx.state.items
          })
      })
      // .then(() => {
      //   return ctx.dispatch('decoratorMinicart').then(() => ctx.state.items)
      // })
  },
  updateMinicart (ctx) {
    if (!ctx.state.cartId) {
      return Promise.reject(new Error('empty cartid'))
    }

    /* var cartItems = Config.API.cart[`items${getSuffixGuest(ctx.rootGetters)}`]
      .replace('{{storeViewCode}}', ctx.rootState.ui.storeViewCode)
      .replace('{{cartId}}', ctx.state.cartId)

    return HttpProvider.get(cartItems)
      .then(resp => {
        ctx.commit('updCartItems', { items: resp.data })
        return resp.data
      }) */
    return ctx.dispatch('totals')
  },
  decoratorMinicart (ctx) {
    const cartItems = []
    const serverItems = ctx.state.total && ctx.state.total.items.length ? ctx.state.total.items : []
    const promiseArr = []
    each(serverItems, serverItem => {
      const sku = serverItem.sku
      if (sku) {
        promiseArr.push(
          ctx.dispatch('product/find', sku, { root: true })
            .then(product => {
              cartItems.push({
                ...product,
                ...serverItem
              })
            })
        )
      }
    })
    return Promise.all(promiseArr)
      .then(() => {
        ctx.commit('updCartItems', { items: cartItems, invalid: true })
      })
  },
  update (ctx, {
    sku,
    itemId,
    qty,
    product,
    append = false,
    variant,
    getGiftInfoFromOptions = true,
    noSync = false
  }) {
    // TODO verify if check stock and pull is essential
    // return ctx.dispatch('checkStock', sku)

    var itemFromCart
    var newQty = qty
    const commonScript = () => {
      if (itemId) {
        itemFromCart = append ? null : find(ctx.state.items, { item_id: itemId })
      } else {
        itemFromCart = append ? null : find(ctx.state.items, { sku: sku })
      }
      if (newQty < 1 && itemFromCart) {
        return ctx.dispatch('delete', itemFromCart.item_id)
      }
    }

    // check product type
    if (product && product.aw_giftcard_options && product.aw_giftcard_options.aw_gc_recipient_email) {
      // add giftcard to cart
      return ctx.dispatch('getCartIDMask', {})
        .then(() => {
          commonScript()
          let filters = {
            giftCardItem: {
              cart_id: ctx.state.cartIdMask,
              cart_items: [{
                aw_giftcard_option: {
                  ...giftCardFormDecorator({ giftOptions: product.aw_giftcard_options, product, getFromOptions: getGiftInfoFromOptions })
                },
                data: {
                  quantity: newQty,
                  sku: product.sku ? product.sku : product.product.sku
                }
              }]
            }
          }
          return Graphql.genericCall(
            {},
            ctx.rootState.user.token,
            ctx.rootState.ui.storeViewCode,
            'addGiftCardOnCart',
            filters,
            false
          )
            .then(res => {
              if (res && res.errors) {
                throw res.errors[0]
              } else {
                return res
              }
            })
            .catch(error => {
              throw error
            })
        })
        .then((res) => {
          if (res.data && res.data.extension_attributes) {
            res.data.item_id = parseInt(res.data.extension_attributes.track_product_id)
          }
          if (!noSync) {
            return ctx.dispatch('syncServerCart', {}).then(() => res.data)
          }
          return res.data
        })
    } else {
      // add product to cart
      return ctx.dispatch('getCartID', {})
        .then(() => {
          commonScript()
          const params = {
            cartItem: {
              item_id: itemFromCart ? itemFromCart.item_id : undefined,
              qty: newQty,
              quoteId: ctx.state.cartId,
              sku: sku
            }
          }
          // configurable product
          if (variant) {
            let configurableItemOptions = []
            for (let key in variant) {
              configurableItemOptions.push({
                option_id: key,
                option_value: variant[key]
              })
            }
            params.cartItem.product_option = {
              extension_attributes: {
                configurable_item_options: configurableItemOptions
              }
            }
          }
          let url = append ? Config.API.cart[`add${getSuffixGuest(ctx.rootGetters)}`] : Config.API.cart[`update${getSuffixGuest(ctx.rootGetters)}`]
          const axiosCall = append ? HttpProvider.post : HttpProvider.put
          return axiosCall(url
            .replace('{{storeViewCode}}', ctx.rootState.ui.storeViewCode)
            .replace('{{token}}', ctx.rootState.user.token || '')
            .replace('{{itemId}}', itemFromCart ? itemFromCart.item_id : '')
            .replace('{{cartId}}', ctx.state.cartId), params)
        })
        .then((res) => {
          if (!noSync) {
            return ctx.dispatch('syncServerCart', {}).then(() => res.data)
          }
          return res.data
        })
    }
  },
  delete (ctx, item) {
    let itemId = item.item_id
    const query = Config.API.cart[`delete${getSuffixGuest(ctx.rootGetters)}`]
      .replace('{{storeViewCode}}', ctx.rootState.ui.storeViewCode)
      .replace('{{cartId}}', ctx.state.cartId)
      .replace('{{itemId}}', itemId)
    return HttpProvider.delete(query, { itemsMap: item.delete_map })
      .then(() => {
        return ctx.dispatch('syncServerCart', {})
      })
  },
  totals (ctx) {
    let url = Config.API.cart[`totals${getSuffixGuest(ctx.rootGetters)}`]
      .replace('{{storeViewCode}}', ctx.rootState.ui.storeViewCode)
      .replace('{{cartId}}', ctx.state.cartId)
    return HttpProvider.get(url)
      .then(res => res.data)
      .then(basket => {
        return ctx.commit('updCart', basket)
      })
  },
  shippingInfo (ctx, { shippingAddress, billingAddress }) {
    if (ctx.getters.isEmptyCart) {
      return Promise.resolve()
    }
    const params = {
      addressInformation: {
        shippingAddress: {
          countryId: ctx.rootState.checkout.shippingAddress.country_id || Config.Theme.default.country
        },
        billingAddress: {
          countryId: ctx.rootState.checkout.billingAddress.country_id || Config.Theme.default.country
        },
        shippingCarrierCode: ctx.rootState.checkout.shippingMethod || Config.Theme.default.shippingMethod,
        shippingMethodCode: ctx.rootState.checkout.shippingMethod || Config.Theme.default.shippingMethod
      }
    }

    if (shippingAddress) {
      params.addressInformation.shippingAddress = shippingAddress
    }
    if (billingAddress) {
      params.addressInformation.billingAddress = billingAddress
    }
    return HttpProvider.post(Config.API.cart[`shippingInfo${getSuffixGuest(ctx.rootGetters)}`]
      .replace('{{storeViewCode}}', ctx.rootState.ui.storeViewCode)
      .replace('{{cartId}}', ctx.state.cartId), params)
      .then(res => {
        if (res.data) {
          ctx.commit('checkout/setPaymentMethods', res.data.payment_methods, { root: true })
          return ctx.commit('updCart', res.data.totals)
        }
      })

    /* return HttpProvider.post(url, params)
      .then(res => res.data)
      .then(shippingInfo => {
        return ctx.commit('updShippingInfo', shippingInfo)
      }) */
  },
  empty (ctx) {
    ctx.commit('updCartId', null)
    ctx.commit('updCartIdMask', null)
    ctx.commit('updCartItems', { items: [], invalid: true })
    ctx.commit('updPullItems', { items: [] })
    ctx.commit('updCart', { })
    ctx.dispatch('checkout/empty', null, { root: true })
  },
  checkStock (ctx, sku) {
    return Vue.http.get(Config.API.cart.stock.replace('{{sku}}', sku))
      .then(res => {
        return res.body.result.is_in_stock
      })
      .catch(err => {
        console.error(err)
        return false
      })
  },
  createOrder (ctx, order) {
    return HttpProvider.put(Config.API.cart[`placeOrder${getSuffixGuest(ctx.rootGetters)}`]
      .replace('{{storeViewCode}}', ctx.rootState.ui.storeViewCode)
      .replace('{{cartId}}', ctx.state.cartId), {
      email: order.addressInformation.shippingAddress.email,
      paymentMethod: {
        method: order.addressInformation.payment_method_code,
        additionalData: order.addressInformation.payment_method_additional
      }
    })
      .then(res => {
        ctx.dispatch('empty')
          .then(() => {
            ctx.dispatch('syncServerCart', { invalid: true })
          })
        return res.data
      })
  },
  restoreCartByOrderId (ctx, orderId) {
    return HttpProvider.put(Config.API.order.restoreQuote
      .replace('{{storeViewCode}}', ctx.rootState.ui.storeViewCode),
    {
      orderId
    })
      .then(res => {
        console.log('res data', res)
      })
  },
  async addCoupon (ctx, coupon) {
    let cartId = await ctx.dispatch('getCartIDMask')
    let obj = Graphql.addCouponOnCart(cartId, coupon, ctx.rootState.user.token, ctx.rootState.ui.storeViewCode)
    return Graphql.doCall(obj.query, obj.variables, obj.token, obj.storeViewCode, false)
  },
  async deleteCoupon (ctx) {
    let cartId = await ctx.dispatch('getCartIDMask')
    let obj = Graphql.removeCouponFromCart(cartId, ctx.rootState.user.token, ctx.rootState.ui.storeViewCode)
    return Graphql.doCall(obj.query, obj.variables, obj.token, obj.storeViewCode, false)
  },
  addGiftCard (ctx, giftCard) {
    let url = Config.API.cart[`giftCard${getSuffixGuest(ctx.rootGetters)}`]
      .replace('{{storeViewCode}}', ctx.rootState.ui.storeViewCode)
      .replace('{{cartId}}', ctx.state.cartId)
      .replace('{{giftCardCode}}', giftCard)
    return HttpProvider.put(url)
      .then(res => {
        return ctx.dispatch('totals')
      })
      .catch(error => {
        throw error
      })
  },
  deleteGiftCard (ctx, giftCardCode) {
    let url = Config.API.cart[`giftCard${getSuffixGuest(ctx.rootGetters)}`]
      .replace('{{storeViewCode}}', ctx.rootState.ui.storeViewCode)
      .replace('{{cartId}}', ctx.state.cartId)
      .replace('{{giftCardCode}}', giftCardCode)
    return HttpProvider.delete(url)
      .then(res => {
        return ctx.dispatch('totals')
      })
      .catch(error => {
        throw error
      })
  },
  mergeCart (ctx, { guestCartID }) {
    // get user guest cartid
    // genericCall (config, token, storeViewCode, graphSchemaType, variables = null, useCache = true) {
    ctx.commit('updCartIdMask', null)
    return ctx.dispatch('getCartIDMask').then(userCartId => {
      if (userCartId) {
        return Graphql.genericCall(
          {},
          ctx.rootState.user.token,
          ctx.rootState.ui.storeViewCode,
          'mergeCarts',
          {
            sourceCartId: guestCartID,
            destinationCartId: userCartId
          },
          false
        )
      } else {
        Logger.error('user cartid not valid')
      }
    })
  },
  init (ctx) {
    const promiseArr = []
    const cartStore = require('@/store/lib/storage').cartStore
    if (ctx.state.cartId) {
      promiseArr.push(cartStore.getItem('items').then(items => ctx.commit('updCartItems', { items: items || [] })))
      promiseArr.push(cartStore.getItem('pullItems').then(items => ctx.commit('updPullItems', { items: items || [] })))
      promiseArr.push(cartStore.getItem('total').then(total => ctx.commit('updCart', total || {})))
      promiseArr.push(ctx.dispatch('syncServerCart', {}))
    }
    return Promise.all(promiseArr)
  }
}
